<template>
  <div class="dictum-information-container">
    <div class="nav-scroller border-bottom mb-2">
      <div class="nav nav-tabs">
        <a class="nav-link active"
           data-toggle="tab"
           href="#assigned-reviewers">
          <i class="fas fa-gavel"></i>
          Revisores asignados</a>
        <a class="nav-link"
           data-toggle="tab"
           href="#assigned-reviewers-evaluation">
          <i class="fas fa-users"></i>
          Revisores asignados en la evaluación</a>
        <a class="nav-link"
           data-toggle="tab"
           href="#committee-dictums-amendment">
          <i class="fas fa-users"></i>
          Dictámenes de comité</a>
      </div>
    </div>
    <div class="tab-content">
      <div id="assigned-reviewers" aria-labelledby="assigned-reviewers-title" class="tab-pane fade show active"
           role="tabpanel">
        <h2 id="assigned-reviewers-title" class="d-none"><i class="fas fa-gavel"></i> Revisores asignados</h2>
        
        <div class="page-section">
          <div class="section-block m-0 p-0">
            <div class="row">
              <div class="col">
                <assigned-reviewers :amendment="amendment"
                                    :committee="committee"
                                    @show-comments="comments => $emit('show-comments', comments)"
                                    @cancel-reviewer="userId => $emit('cancel-reviewer', userId)"></assigned-reviewers>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div id="assigned-reviewers-evaluation" aria-labelledby="assigned-reviewers-evaluation-title"
           class="tab-pane fade"
           role="tabpanel">
        <h2 id="assigned-reviewers-evaluation-title" class="d-none"><i class="fas fa-users"></i> Revisores asignados en
                                                                                                 evaluación</h2>
        <div class="page-section">
          <div class="section-block m-0 mt-2 p-0">
            <div class="row">
              <div class="col">
                <assigned-reviewers-protocol :protocol="protocol"
                                             :committee="committee"
                                             :amendment="amendment"
                                             @show-comments="comments => $emit('show-comments', comments)"
                                             @resend-invitation="userId => $emit('resend-invitation', userId)"></assigned-reviewers-protocol>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div id="committee-dictums-amendment" aria-labelledby="committee-dictums-amendment-title" class="tab-pane fade"
           role="tabpanel">
        <h2 id="committee-dictums-amendment-title" class="d-none"><i class="fas fa-users"></i> Dictámenes de comité
        </h2>
        <div class="page-section">
          <div class="section-block m-0 mt-2 p-0">
            <div class="row">
              <div class="col">
                <committee-dictums :amendment="amendment"
                                   :committee="committee"
                                   @show-comments="comments => $emit('show-comments', comments)"></committee-dictums>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicTable from '../../ui/DynamicTable'
  import CommitteeDictums from './CommitteeDictums'
  import AssignedReviewers from './AssignedReviewers'
  import AssignedReviewersProtocol from './AssignedReviewersProtocol'
  
  export default {
    name: 'DictumInformation',
    components: {
      CommitteeDictums,
      DynamicTable,
      AssignedReviewers,
      AssignedReviewersProtocol,
    },
    props: {
      protocol: Object,
      amendment: Object,
      committee: Object,
    },
  }
</script>
